import React, { useEffect, useState } from 'react';
import styles from './toast.module.css';
import Image from 'next/image';
type ToastProps = {
    id: number;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    removeToast: (id: number) => void;
};

const Toast: React.FC<ToastProps> = ({ id, message, type, removeToast }) => {
    const [removing, setRemoving] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setRemoving(true);
            setTimeout(() => removeToast(id), 300);
        }, 3000);

        return () => clearTimeout(timer);
    }, [id, removeToast]);

    return (
        <div className={`${styles.toast} ${styles[type]}  ${removing ? `${styles.removing}` : ''}`}>
            <Image width={18} height={18} src={`/assets/images/toast-${type}.svg`} alt={type} />
            <div>{message}</div>
        </div>
    );
};

export default Toast;
